import { createContext, useContext } from 'react';
export const FloatingButtonGroupContext = /*#__PURE__*/createContext({
  setFloatingButtonGroupActiveEl: null,
  floatingGroup: false,
  srOnly: false
});
export const {
  Provider: FloatingButtonGroupContextProvider
} = FloatingButtonGroupContext;
export const useFloatingButtonGroupContext = () => {
  return useContext(FloatingButtonGroupContext);
};